import { render } from "./TeleportEditorCmp.vue?vue&type=template&id=46f3e6d4"
import script from "./TeleportEditorCmp.vue?vue&type=script&lang=js"
export * from "./TeleportEditorCmp.vue?vue&type=script&lang=js"

import "./TeleportEditorCmp.vue?vue&type=style&index=0&id=46f3e6d4&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__